<template>
  <v-dialog v-model="visible" max-width="400">
    <v-card>
      <v-card-title class="text-h6 grey lighten-1">
         <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">{{icono}}</v-icon>
         {{titulo}}
      </v-card-title>

      <v-card-text class="pa-0">
        <div class="caja-recibo">
          <div class="recibo texto-seleccionable">{{recibo}}</div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="green darken-2" @click="botonImprimirClick">
          {{ $t ('Imprimir') }}
        </v-btn>
        <v-btn text @click="botonCerrarClick">
          {{ $t ('Cerrar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    this.promesaResolve = null;
    this.promesaReject = null;
    this.botonImprimirClicado = false;
    return {
      visible: false,
      icono: '',
      titulo: '',
      recibo: '',
    }
  },
  watch: {
    visible () {
      if (!this.visible) { // al cerrarse la ventana, finalizamos la promesa. Si se ha pulsado el boton imprimir, la resolvemos; si no, la rechazamos
        if (this.botonImprimirClicado)
          this.promesaResolve();
        else
          this.promesaReject();
      }
    }
  },
  methods: {
    abrirVentana (titulo, recibo, icono = 'mdi-file-outline') {
      this.icono = icono;
      this.titulo = titulo;
      this.recibo = recibo;

      this.botonImprimirClicado = false;
      let resultado = new Promise ((resolve, reject) => {
        this.promesaResolve = resolve;
        this.promesaReject = reject;
      });

      this.visible = true;

      return resultado;
    },
    botonImprimirClick () {
      this.botonImprimirClicado = true;
      this.visible = false;
    },
    botonCerrarClick () {
      this.visible = false;
    }
  }
}
</script>

<style scoped>

</style>